<div class="input-cell">
  <ng-select
    *ngIf="!hasNoSelection; else noSelection"
    [(ngModel)]="currentValue"
    [virtualScroll]="listItems?.length > virtualScrollerThreshold"
    i18n-placeholder="Select"
    placeholder="Select"
    appendTo="body"
    class="list-cell"
    (open)="register()"
    (blur)="closeDropDown()"
    (ngModelChange)="handleOnChange($event)"
    #select
  >
    <ng-option [value]="clearOption" *ngIf="currentValue"
      ><span class="clear-option">{{ clearOption }}</span></ng-option
    >
    <ng-option *ngFor="let item of listItems" [value]="item.value">
      <div class="sm-flex" data-test="list-item">
        <div
          class="sm-text-transparent rounded-square {{ item?.style || styleVariants.None }}"
        >
          .
        </div>
        <span class="list-item-label">{{ item.value }}</span>
      </div>
    </ng-option>
    <ng-option *ngIf="!listItems" disabled>Loading...</ng-option>
  </ng-select>
</div>

<ng-template #noSelection><div i18n>No selection</div></ng-template>
